import styled from "styled-components";
import logoDIM from "../../../assets/images/generico/LogoDIMImage.png";

export const CardContainer = styled.div`
  width: 370px;
  min-height: 168px;
  border: 1px solid var(--color-grey90);
  border-radius: 8px;
  box-shadow: 0px 50px 80px rgba(0, 0, 0, 0.07),
    0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
  min-width: 360px;
`;

export const CardTitle = styled.div`
  padding: 10px 20px;
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;

export const CardBody = styled.div`
  background-image: url(${logoDIM});
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 1;
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  gap: ${({ $proceso }) => ($proceso === "labo" ? "20px" : "8px")};
  .logo-dim {
    position: fixed;
    margin-top: -2vh;
    margin-left: 11vh;
    z-index: -2;
  }
`;

export const DiaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DiaTexto = styled.div`
  display: flex;
  gap: 8px;
  .boxDia {
    width: max-content;
  }
`;

export const ConfirmarBtn = styled.button`
  width: 110px;
  height: 42px;
  border-radius: 8px;
  border: 2px solid var(--color-primary);
  background: transparent;
  transition: background-color 0.1s ease-out; /* Transición para el cambio de fondo */
  &:hover {
    border: none;
    background: var(--color-primary);
    color: white;
  }
`;
